import {
  CATEGORY_YOUNG_LEADER,
  CATEGORY_WOMEN_IN_TECH,
  CATEGORY_WOMEN_IN_TECH_2026,
  CATEGORY_DIGITAL_CATALYST,
  AWARD_CATEGORIES,
} from './categoryNames';
export {
  CATEGORY_INNOVATION,
  CATEGORY_SUSTAINABLE,
  CATEGORY_DIGITAL_TRANSFORMATION,
  CATEGORY_AI,
  CATEGORY_YOUNG_LEADER,
  CATEGORY_WOMEN_IN_TECH,
  CATEGORY_NEW_BUSINESS_VENTURE,
  CATEGORY_WOMEN_IN_TECH_2026,
  CATEGORY_DIGITAL_CATALYST,
  AWARD_CATEGORIES,
  CATEGORIES_BY_YEAR,
} from './categoryNames';

const currentYear = new Date().getFullYear();
export const CURRENT_AWARD_YEAR: number = currentYear;

export const INDIVIDUAL_CATEGORIES: string[] = [
  CATEGORY_YOUNG_LEADER,
  CATEGORY_WOMEN_IN_TECH,
  CATEGORY_WOMEN_IN_TECH_2026,
  CATEGORY_DIGITAL_CATALYST,
];

export const ORGANIZATION_CATEGORIES: string[] = AWARD_CATEGORIES.filter(
  category => !INDIVIDUAL_CATEGORIES.includes(category)
);

export const categoryToVistaMapping = (category: string): string => {
  return category.toUpperCase();
};

export const vistaToRubricMapping = (vistaName: string): string => {
  let parts = vistaName.split(' ');
  parts = parts.map(p => {
    if (p === 'AI') return 'AI';
    if (p === 'IN') return 'in';
    if (/^\d{4}$/.test(p)) return p;
    return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
  });
  return parts.join(' ') + ' Rubric';
};
